export const ANALYTICS_CHANNEL = 'jql-editor';

export enum EventType {
	OPERATIONAL = 'operational',
	SCREEN = 'screen',
	TRACK = 'track',
	UI = 'ui',
}
